<template>
  <div class="pdf-container">
    <object :data="pdfUrl" type="application/pdf" width="100%" height="100%">
      <p>
        It appears your browser doesn’t support inline PDFs.
        <a :href="pdfUrl" target="_blank">Download the PDF</a>.
      </p>
    </object>
  </div>
</template>

<script>
export default {
  name: "PdfViewer",
  props: {
    pdfUrl: {
      type: String,
      required: true,
    },
  },
};
</script>

<style scoped>
.pdf-container {
  height: 100%;
  /* if you want to absolutely fix it over everything: */
  /* position: fixed;
       top: 0; left: 0; right: 0; bottom: 0; */
}
</style>
